var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRating = function SvgRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "m15.418 7.81 1.301 2.283a.7.7 0 0 0 .467.354l2.503.572a1.74 1.74 0 0 1 .884 2.829l-1.697 1.98a.76.76 0 0 0-.177.572l.254 2.638a1.676 1.676 0 0 1-2.326 1.746l-2.347-1.06a.7.7 0 0 0-.58 0l-2.348 1.06a1.676 1.676 0 0 1-2.298-1.746l.248-2.638a.76.76 0 0 0-.177-.573l-1.697-1.98a1.74 1.74 0 0 1 .884-2.828l2.503-.572a.7.7 0 0 0 .467-.354l1.308-2.284a1.64 1.64 0 0 1 2.828 0"
  })));
};
export default SvgRating;